import React from 'react';
import ErrorBoundary from './error_boundary';
import { Commons_Cms_DynamicPageQuery } from '../gql/graphql';
import { COMPONENT_OUTPUT } from '../cms/component_output';
import * as COMPONENT_TYPES from '../cms/component_types';
import { useUser } from '../user_hooks';
import { inMobileApp } from '../user_context_helpers';

type Commons_Cms_DynamicPageQuery_Components = Commons_Cms_DynamicPageQuery['pages'][0]['components'][0];

type Commons_Cms_DynamicPageQuery_Page = Commons_Cms_DynamicPageQuery['pages'][0];

interface IProps {
  component: Commons_Cms_DynamicPageQuery_Components;
  canSsr: boolean;
  layoutSlug: string;
  position: number;
  withSidebar?: boolean;
  page?: Commons_Cms_DynamicPageQuery_Page;
}

const MAX_SSR_COMPONENT_POSITION = 3;

export default function CmsPageComponent({
  component,
  canSsr,
  layoutSlug,
  position,
  withSidebar = false,
  page = undefined,
}: IProps) {
  const user = useUser();

  const ComponentClass = COMPONENT_OUTPUT[component.componentType];
  const props = JSON.parse(component.data) || {};

  if (component.componentType === COMPONENT_TYPES.LISTINGS_COLLECTION) {
    props.userShippingRegion = user.shippingRegionCode;
  }

  if (component.componentType === COMPONENT_TYPES.RECENTLY_VIEWED_LISTINGS) {
    props.loggedOut = user.loggedOut;
  }

  props.layoutSection = component.layoutSection;
  props.pagePosition = position;
  props.ssr = (canSsr && position < MAX_SSR_COMPONENT_POSITION);
  props.inMobileApp = inMobileApp(user);
  props.layoutSlug = layoutSlug;
  props.withSidebar = withSidebar;
  props.componentId = component.id;

  return (
    <ErrorBoundary
      errorName="cms-component-error"
      errorData={{
        component_type: component.componentType,
        component_id: component.id,
        page_id: page?.id,
        page_title: page?.title || page?.metaTitle,
      }}
    >
      <ComponentClass {...props} />
    </ErrorBoundary>
  );
}
